var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"tbButton mr-2 ml-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('tb-button-click')}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_c('CIcon',{attrs:{"name":"cil-chevron-right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }